import { render, staticRenderFns } from "./CTitle.vue?vue&type=template&id=3f58a975&scoped=true"
import script from "./CTitle.vue?vue&type=script&lang=js"
export * from "./CTitle.vue?vue&type=script&lang=js"
import style0 from "./CTitle.vue?vue&type=style&index=0&id=3f58a975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f58a975",
  null
  
)

export default component.exports